<template>
  <tool-advance-filter-content
    :contentInfo="contentInfo"
    :chartProperties="chartProperties"
    :chartData="chartGraphData"
    :selectedComponent="selectedChartComponent"
    :baselineTitle="baselineRow.title"
    :headerbaseline="baselineHeader"
    :rowsbaseline="baselineRow.rows"
    @editableRowButtonClick="genericMethodClick"
    :addButtonText="addButtonText"
    :updateButtonText="updateButtonText"
    :headers="headers"
    :rows="rows"
    :infoText="infoText"
    :infoError="infoError"
    :singleHeading="singleHeading"
    :singleHeadingOptions="singleHeadingOptions"
    :singleHeadingButtonText="singleHeadingButtonText"
    :gridSplitId="gridSplitId"
    :isShowHint="isShowHint"
    :emptyChartMessage="emptyChartMessage"
    @addRow="addRow"
    @setFocusOnRowElement="setFocusOnRowElement"
    :focusElementName="focusElementName"
    :gridButtonTemplate="gridButtonTemplate"
    @GridSelectionChange="AddNewTypeRow"
    :rowTemplateButton="rowTemplateButton"
    @OuterRowButtonClick="genericMethodClick"
    @onChange="OnOptionChange"
    @rowTemplateButtonClick="genericMethodClick"
    :rowOuterButton="rowOuterButton"
    :emptyGridData="emptyGridData"
    @removeRow="removeRow"
    @onChangeChartTab="onChangeChartTab"
    :tableViewSettings="tableSetting"
    :showTableView="showTable"
    :buttonDataTypeConfig="buttonDataTypeConfig"
    :buttonViewTypeConfig="buttonViewTypeConfig"
    @onSelectDataTypeFilter="onSelectDataTypeFilter"
    @onSelectViewTypeFilter="onSelectViewTypeFilter"
  ></tool-advance-filter-content>
</template>

<script>
import { ToolAdvanceFilterContent } from "../../component/tool";
import { LoanAdvanceFilterContent, ICELoanIntegration } from "../../mixin";
import { AdvanceFilter, DATETYPE } from "../../helpers/constant";
import { mapGetters } from "vuex";
import { GET_LIABLITY_INFORMATION } from "../../helpers/vuex-constants";
import _ from "lodash";
import { GET_SELECTED_LIABLITY_INFORMATION } from "../../helpers/vuex-constants";

export default {
  props: {
    tableViewSettings: {
      type: Object,
    },
    showTableView: {
      type: Boolean,
      default: false,
    },
    baselineData: {
      type: Object,
    },
  },
  components: { ToolAdvanceFilterContent },
  mixins: [LoanAdvanceFilterContent, ICELoanIntegration],
  computed: {
    gridButtonTemplate() {
      return this.EnableDisableButtons();
    },
    legendItems() {
      return ["Base Interest Rate", "Interest Rate Adjustments"];
    },
    baselineFilterObject() {
      return Object.assign({}, this.baselineData);
    },
    ...mapGetters("loan", {
      selectedLoanData: GET_SELECTED_LIABLITY_INFORMATION,
      getLiablityInformation: GET_LIABLITY_INFORMATION,
    }),
  },
  mounted() {
    this.fillLoanModel(AdvanceFilter.Interest_Rate);
    this.validations(
      this.baselineFilterObject.advancedetails,
      AdvanceFilter.Interest_Rate
    );
  },
  async created() {
    this.setChartViewTypeDropDown();
    //  this.setChartDataTypeDropDown();
  },
  data() {
    return {
      buttonDataTypeConfig: [],
      buttonViewTypeConfig: [],
      emptyGridData: {
        title: "Click to add Interest Rate Adjustment",
        message: "",
        imagepath: "../../assets/icons/dollar.svg",
        buttonVisible: true,
        list: [],
      },
      focusElementName: "",
      timeSeriesChartData: this.getTimeSeriesCoordinate(
        this.baselineData.advancedetails,
        AdvanceFilter.Interest_Rate,
        this.baselineData.projectionYear
      ),
      emptyChartMessage: {
        message: "Add Additional Interest Rate to create a chart.",
        btnTxt: "",
      },
      baselineRow: {
        title: "Baseline Interest Rate",

        rows: [
          {
            interestRate: { value: this.baselineData.interestRate },
          },
        ],
      },
      baselineHeader: this.getEditBaselineHeader(),
      contentInfo: {
        heading: "Interest Rate",
        subHeading:
          "You can enter in different interest rates at different time periods.",
      },
      updateButtonText: "Update Graph",
      addButtonText: "Add new",
      infoText: [""],
      infoError: false,
      singleHeading: "Interest Rate Adjustments",
      singleHeadingOptions: [
        {
          key: 1,
          value: "",
          fields: ["Amount", "StartDate", "EndDate", "Description"],
          overlapvalidations: true,
        },
      ],
      singleHeadingButtonText: "",
      gridSplitId: "",
      isShowHint: true,
      headers: [
        {
          type: "FormatInput",
          label: "Interest Rate",
          cols: 2,
          key: "Amount",
          isAllowOnlyNumber: true,
          AllowOnlyDecimalTill: 2,
          appendText: "%",
          length: 5,
          max: 99.99,
          validation: true,
          style: {
            width: "120px",
          },
        },
        {
          type: "MonthPickerSelect",
          displayTop: true,
          showLeft: false,
          typing: true,
          label: "Start",
          cols: 1,
          key: "StartDate",
          listdata: this.startOptionsNew(),
          sort: "years",
          minYear: 2022,
          yearTerm: 50,
          style: {
            width: "160px",
            overflow: "visible",
          },
          validation: true,
        },

        {
          type: "MonthPickerSelect",
          displayTop: true,
          showLeft: false,
          typing: true,
          label: "End",
          cols: 1,
          key: "EndDate",
          listdata: this.startOptionsNew(),
          sort: "years",
          minYear: 2022,
          yearTerm: 50,
          style: {
            width: "160px",
            overflow: "visible",
          },
          validation: true,
        },
        {
          type: "Input",
          label: "Description",
          placeholder: "e.g Change in Rates",
          isAllowToAddNextRow: true,
          cols: 1,
          key: "Description",
          isAllowOnlyNumber: false,
          appendText: "",
          length: 200,
          validation: false,
        },

        {
          type: "Icon",
          label: "",
          iconText: "Validation",
          icon: "check",
          cols: 1,
          isShowDelete: true,
          isShowSuccess: false,
          class: "cf-Icon-Align",
          style: {
            width: "50px",
          },
          data: [
            {
              label: "",
              iconText: "Delete",
              icon: "trash",
              type: "icon",
              path: "",
              action: "delete",
            },
          ],
        },
      ],
      rows: this.fillGrid(),
      rowTemplateButton: [
        {
          icon: "plus",
          size: "medium",
          variation: "flat",
          text: "Add New",
          callBackMethod: "AddNewTypeRow",
          isdisabled: false,
          key: "AddNewTypeRow",
        },
      ],
      rowOuterButton: [
        // {
        //   icon: "trash",
        //   size: "large",
        //   variation: "icon-only",
        //   text: "Add New",
        //   callBackMethod: "DeleteSubtype",
        //   isdisabled: false,
        //   key: "deletesubtype",
        // },
      ],

      gridButtonTemplatedata: [
        {
          icon: "eye",
          size: "medium",
          variation: "primary",
          text: "Preview Graph",
          callBackMethod: "UpdateGraph",
          isdisabled: false,
          key: "UpdateGraph",
        },
        // {
        //   icon: "plus",
        //   size: "medium",
        //   variation: "secondary",
        //   isdisabled: false,
        //   text: "Add New",
        //   callBackMethod: "addNewRow",
        //   key: "addRow",
        // },
        {
          size: "medium",
          variation: "secondary",
          isdisabled: true,
          text: "Reset",
          callBackMethod: "reset",
          key: "reset",
        },
      ],
    };
  },
  beforeMount() {
    this.validations(
      this.baselineFilterObject.advancedetails,
      AdvanceFilter.Interest_Rate
    );
  },
  beforeDestroy() {
    this.fillLoanModel(AdvanceFilter.Interest_Rate);
    this.validations(
      this.baselineFilterObject.advancedetails,
      AdvanceFilter.Interest_Rate
    );
  },
  methods: {
    EnableDisableButtons() {
      let difference = true;
      let Loans = this.getLiablityInformation.filter(
        (sr) => sr.liabilityGuid == this.selectedLoanData.liabilityGuid
      );
      let ExistingData = Loans[0].advancedetails
        .filter((sr) => sr.typeId == AdvanceFilter.Interest_Rate)
        .map(function (t) {
          let p = {};
          p.amount = t.amount;
          p.description = t.description;
          p.startDate = t.startDate;
          p.startDateType = t.startDateType.toString();
          p.endDate = t.endDate;
          p.endDateType = t.endDateType.toString();
          return p;
        });
      let CurrentDataObject = [];
      for (let i = 0; i < this.rows.length; i++) {
        if (ExistingData.length > 0)
          CurrentDataObject.push({
            amount: this.rows[i].Amount.value,
            description: this.rows[i].Description.value,
            startDate: this.rows[i].StartDate.value,
            startDateType: this.rows[i].StartDateType.value.toString(),
            endDate: this.rows[i].EndDate.value,
            endDateType: this.rows[i].EndDateType.value.toString(),
          });
        else {
          if (!this.validatebyrow(this.rows[i], this.rows[i].subTypeId.value)) {
            difference = false;
            break;
          }
        }
      }
      if (ExistingData.length > 0) {
        difference = _.isEqual(ExistingData, CurrentDataObject);
      }
      this.enableResetButton(difference, "UpdateGraph");
      this.enableResetButton(difference, "reset");
      return this.gridButtonTemplatedata;
    },
    DeleteSubtype(data) {
      this.rows = this.rows.filter((x) => x.subTypeId.value != data);
    },

    // GridSelectionChange(data) {

    //   this.rows.push(this.fillData(undefined, data.key));
    //   let newIndex = this.rows.length - 1;
    //   let firstElement = this.singleHeadingOptions.filter(x => x.key == data.key)[0].fields[0] + newIndex;
    //   setTimeout(() => {
    //     this.focusElementName = firstElement;
    //   }, 100);
    // },

    fillGrid() {
      let gridRows = [];
      if (this.baselineData.advancedetails != null) {
        let data = this.baselineData.advancedetails.filter(
          (sr) => sr.typeId.value == AdvanceFilter.Interest_Rate
        );
        if (data != null && data.length > 0) {
          gridRows = this.emptyGridRow(data);
        }
        //this.getinsertEmptyRows(gridRows);
      }
      return gridRows;
    },

    async UpdateGraph() {
      this.fillLoanModel(AdvanceFilter.Interest_Rate);
      if (
        !this.validations(
          this.baselineFilterObject.advancedetails,
          AdvanceFilter.Interest_Rate
        )
      ) {
        await this.UpdateGraphByICEApi();

        this.timeSeriesChartData = this.getTimeSeriesCoordinate(
          this.baselineFilterObject.advancedetails,
          AdvanceFilter.Interest_Rate,
          this.baselineData.projectionYear
        );
        this.onChangeChartTab(this.selectedChartComponent);
      }
    },

    getUserInputData(userInputRows) {
      let addtionalData = [];
      let rows = Object.assign([], userInputRows);
      rows = this.ResetMonthPickerValue(rows);
      for (let i = 0; i < rows.length; i++) {
        if (!this.validatebyrow(rows[i], rows[i].subTypeId.value)) {
          addtionalData.push({
            amount: {
              value: rows[i].Amount.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].Amount.disable,
            },
            startDateType: {
              value: rows[i].StartDateType.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].StartDateType.disable,
            },
            startDate: {
              value: rows[i].StartDate.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].StartDate.disable,
            },
            endDateType: {
              value: rows[i].EndDateType.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].EndDateType.disable,
            },
            endDate: {
              value: rows[i].EndDate.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].EndDate.disable,
            },

            description: {
              value: rows[i].Description.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].Description.disable,
            },
            typeId: {
              value: AdvanceFilter.Interest_Rate,
              IsError: false,
              ErrorText: [],
            },
            subTypeId: {
              value: rows[i].subTypeId.value,
              IsError: false,
              ErrorText: [],
            },
            newRow: false,
          });
        }
      }
      return addtionalData;
    },
    setFocusOnRowElement() {
      this.focusElementName = this.headers[0].key + "0";
    },
    fillData(data, subtypeid) {
      let IsDataundfined = data == undefined;
      let startDateType = IsDataundfined
        ? 0
        : data.startDateType.value == 0
        ? DATETYPE.Other
        : data.startDateType.value;
      let endDateType = IsDataundfined
        ? 0
        : data.endDateType.value == 0
        ? DATETYPE.Other
        : data.endDateType.value;
      let emptyObject = {
        Amount: {
          value: IsDataundfined ? "0" : data.amount.value,
          IsError: IsDataundfined ? false : data.amount.IsError,
          ErrorText: IsDataundfined ? [] : data.amount.ErrorText,
          disable: IsDataundfined ? false : data.amount.disable,
        },
        StartDateType: {
          value: IsDataundfined ? 0 : data.startDateType.value,
          IsError: IsDataundfined ? false : data.startDateType.IsError,
          ErrorText: IsDataundfined ? [] : data.startDateType.ErrorText,
          disable: IsDataundfined ? false : data.startDateType.disable,
        },
        StartDate: {
          value: IsDataundfined ? "" : data.startDate.value,
          IsError: IsDataundfined ? false : data.startDate.IsError,
          ErrorText: IsDataundfined ? [] : data.startDate.ErrorText,
          text: IsDataundfined
            ? ""
            : this.startOptionsNew().filter((x) => x.value == startDateType)[0]
                .text,
        },
        EndDateType: {
          value: IsDataundfined ? 0 : data.endDateType.value,
          IsError: IsDataundfined ? false : data.endDateType.IsError,
          ErrorText: IsDataundfined ? [] : data.endDateType.ErrorText,
          disable: IsDataundfined ? false : data.endDateType.disable,
        },
        EndDate: {
          value: IsDataundfined ? "" : data.endDate.value,
          IsError: IsDataundfined ? false : data.endDate.IsError,
          ErrorText: IsDataundfined ? [] : data.endDate.ErrorText,
          text:
            IsDataundfined || data.endDate.value == ""
              ? ""
              : this.startOptionsNew().filter((x) => x.value == endDateType)[0]
                  .text,
        },
        Description: {
          value: IsDataundfined ? "" : data.description.value,
          IsError: IsDataundfined ? false : data.description.IsError,
          ErrorText: IsDataundfined ? [] : data.description.ErrorText,
          disable: IsDataundfined ? false : data.description.disable,
        },
        subTypeId: {
          value: IsDataundfined ? subtypeid : data.subTypeId.value,
          IsError: IsDataundfined ? false : data.subTypeId.IsError,
          ErrorText: IsDataundfined ? [] : data.subTypeId.ErrorText,
          disable: IsDataundfined ? false : data.subTypeId.disable,
        },
        newRow: IsDataundfined ? true : false,
      };
      return emptyObject;
    },
    emptyGridRow(data) {
      if (data == undefined) {
        return this.fillData();
      } else {
        let gridData = [];
        for (let i = 0; i < data.length; i++) {
          gridData.push(this.fillData(data[i]));
        }
        return gridData;
      }
    },

    editBaseLineButton_Click() {
      this.baselineHeader = [
        {
          type: "Input",
          label: "Interest rate",
          currencyFormat: "",
          appendText: "%",
          key: "interestRate",
          isAllowOnlyNumber: true,
          AllowOnlyDecimalTill: 2,
          length: 5,
          max: 99.99,
          class: "",
          cols: 2,
          isdisabled: false,
        },
        {
          type: "Button",
          label: "Save",
          variation: "primary",
          key: "save",
          class: "shrink",
          cols: 1,
          isdisabled: false,
          callBackMethod: "saveBaseLineButton_Click",
        },
        {
          type: "Button",
          label: "Cancel",
          variation: "flat",
          key: "cancel",
          class: "shrink",
          cols: 1,
          isdisabled: false,
          callBackMethod: "cancelBaseLineButton_Click",
        },
      ];
    },
    saveBaseLineButton_Click(data) {
      if (
        data[0].interestRate.value !== this.baselineFilterObject.interestRate
      ) {
        this.enableResetButton(false, "UpdateGraph");
      }
      this.baselineFilterObject.interestRate = data[0].interestRate.value;
      this.$emit("resetBaselineData", this.baselineFilterObject);
      this.cancelBaseLineButton_Click();
    },
    cancelBaseLineButton_Click() {
      this.baselineRow.rows[0].interestRate.value =
        this.baselineFilterObject.interestRate;
      this.baselineHeader = this.getEditBaselineHeader();
    },

    getEditBaselineHeader() {
      return [
        {
          type: "Input",
          label: "Interest rate",
          appendText: "%",
          key: "interestRate",
          isAllowOnlyNumber: true,
          class: "",
          cols: 2,
          isdisabled: true,
          isEditiable: true,
          AllowOnlyDecimalTill: 2,
          length: 5,
          max: 99.99,
        },
        {
          type: "EditButton",
          label: "Edit",
          variation: "flat",
          key: "edit",
          icon: "pencil",
          class: "flexiblePosition",
          cols: 3,
          isdisabled: false,
          size: "small",
          callBackMethod: "editBaseLineButton_Click",
        },
      ];
    },
    reset() {
      let Loans = this.getLiablityInformation.filter(
        (sr) => sr.liabilityGuid == this.selectedLoanData.liabilityGuid
      );
      let selectedIntData = Loans[0].advancedetails.filter(
        (sr) => sr.typeId == AdvanceFilter.Interest_Rate
      );
      if (selectedIntData.length > 0) {
        let advanceData = [];
        for (let i = 0; i < selectedIntData.length; i++) {
          advanceData.push({
            Amount: {
              value: selectedIntData[i].amount,
            },
            StartDate: {
              value: selectedIntData[i].startDate,
              disable:
                selectedIntData[i].startDateType != DATETYPE.Other
                  ? true
                  : false,
            },
            StartDateType: {
              value: selectedIntData[i].startDateType,
            },
            EndDate: {
              value: selectedIntData[i].endDate,
              disable:
                selectedIntData[i].endDateType != DATETYPE.Other ? true : false,
            },
            EndDateType: {
              value: selectedIntData[i].endDateType,
            },
            Description: {
              value: selectedIntData[i].description,
            },
            typeId: {
              value: AdvanceFilter.Interest_Rate,
            },
            subTypeId: {
              value: selectedIntData[i].subTypeId,
            },
          });
        }
        this.rows = advanceData;
      } else {
        this.rows = [];
        this.getinsertEmptyRows(this.rows);
      }
      this.enableResetButton(false, "reset");
    },
  },
};
</script>
<style lang="scss" module></style>
